module.exports = __webpack_public_path__ + "site/img/38.55336197.jpg";